import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';
import { UploadResponsePayload } from 'app/types/fileProcessingService';

export const ALLOWED_CARD_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg'];

export const isAllowedCardImage = (file: File): boolean => {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  return ALLOWED_CARD_IMAGE_EXTENSIONS.includes(extension);
};

/**
 * Uploads a recognition card image through the file-processing-service presigned
 * flow and returns the public URL of the stored object.
 *
 * FPS returns a presigned PUT URL, the file is uploaded directly to S3, and the
 * public URL is that same URL without its query string. `companyId` is omitted
 * for ASLAN_ADMIN default-card uploads (no company scope).
 */
export const uploadRecognitionCardImage = async (
  file: File,
  companyId?: string
): Promise<string> => {
  const { url } = (await FileProcessingApiHandler.getUploadPreSignedUrl(
    file.name,
    companyId,
    'RECOGNITION_CARD'
  )) as UploadResponsePayload;

  const response = await fetch(url, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
  });

  if (!response.ok) {
    throw new Error(`Failed to upload recognition card image: ${response.statusText}`);
  }

  const uploadedUrl = new URL(url);
  return `${uploadedUrl.origin}${uploadedUrl.pathname}`;
};
